// extracted by mini-css-extract-plugin
export default {"activity_revision_container":"ActivityDescription_activity_revision_container__GJr+q"};